import { BaseView } from './BaseView';
import { Member } from './Member';
import { registerSchema } from './transform';

export class Photo {
  Id: number = 0;
  Guid: string = '';
  DatePosted: Date = new Date();
  IsProfilePhoto: boolean = false;
  IconUrl: string = '';
  FullSizeUrl: string | null = '';
  CommentsCount: number = 0;
  LikesCount: number = 0;
  LikedByViewer: boolean = false;
  Caption: string = '';
  Member: Member = new Member();

  IsOwner: boolean = false;
  /** Viewer is staff and not the owner: may delete the photo and sees its rating (website only in the UI). */
  CanModerate: boolean = false;
  IsPublic: boolean = false;
  /// Indicates the photo requires premium access to view.
  /// When true, FullSizeUrl will be null and only IconUrl (blurred) is available.
  IsLocked: boolean = false;
  EligibleForReview: boolean = false;
  /// Photo rating text identifier for frontend translation.
  /// Null if viewer is not the photo owner.
  /// Possible values: "pending", "public", "public-sensitive", "private", "banned", "message"
  Rating: string | null = null;

  /// Review status text identifier for frontend display.
  /// Null if viewer is not the photo owner.
  /// Possible values: "none", "queued", "reviewed"
  Review: string | null = null;

  get HasCaption(): boolean {
    return (this.Caption?.length ?? 0) > 0;
  }

  get IsLiked(): boolean {
    return this.LikedByViewer;
  }

  set IsLiked(value: boolean) {
    this.LikedByViewer = value;
  }
}

export class PhotosView extends BaseView {
  PhotosItems: Photo[] = [];
  SafeModeOff: boolean | null = null;
  HasPhotosHiddenBySafeBrowsing: boolean | null = null;
  /// True when the profile owner is premium, the viewer is not, and the folder has more than 12 photos.
  HasExtendedPhotoPreview: boolean | null = null;
}

registerSchema(Photo, {
  DatePosted: 'date',
  Member,
});

registerSchema(PhotosView, {
  PhotosItems: [Photo],
});
